import ModuleModel from 'models/ModuleModel'

export default class ModulesCollection extends Backbone.Collection {

    get model() {
        return ModuleModel
    }

    get comparator() {
        return 'sequence'
    }

    preinitialize() {
        this.constructor.type = 'modules'
    }

    initialize(data, options = {}) {
        const groupModel = options.groupModel
        if (groupModel) {
            for (const chapter of groupModel.chapters) {
                if (chapter.get('Module')) {
                    // Create module model for each unique model found in chapter data.
                    if (!this.has(chapter.get('Module').id)) {
                        const newModuleModel = new ModuleModel(
                            {
                                ...chapter.get('Module'),
                                groupId: groupModel.id,
                            },
                            {
                                groupModel,
                            }
                        )
                        this.push(newModuleModel)
                    }
                    chapter.set({moduleId: chapter.get('Module').id})
                    chapter.unset('Module', {silent: true})
                }
            }

            // Create "dummy" module that contains all chapters of this group
            // that don't belong to a module.
            // Only create this if the group contains a non-zero number
            // of modules.
            if (this.length) {
                this.push(new ModuleModel(
                    {
                        id: 0,
                        title: window.i18n.gettext('Other chapters'),
                        groupId: groupModel.id,
                    },
                    {
                        groupModel,
                    }
                ))

                // Add the dummy module to the remaining chapters
                for (const chapter of groupModel.chapters) {
                    if (!chapter.has('moduleId')) {
                        chapter.set('moduleId', 0)
                    }
                }

                // Set sequence on all module models.
                this.invoke('setSequence')
            }
        }
    }

}
